(function () {
  const modal = document.querySelector('[data-global-modal]');
  if (!modal) return;
  
  const modalVideoContainer = document.querySelector('[data-modal-container]');
  const allTriggers = document.querySelectorAll('[data-modal-trigger]');
  const closeButton = modal.querySelector('[data-global-modal-close-button]');
  const html = document.querySelector('html');
  let ogVideoWrapper;
  let videoContainer;
  let modalPlayer;
  
  const initPlyr = (player, type, url, isIFrame) => {
    const options = {
      controls: true,
      loop: true,
      muted: false,
      responsive: true,
      bigPlayButton: isIFrame ? false : true,
      techOrder: [`${type}`, "html5"],
      sources: [{ "type": "video/" + type, "src": url}],
      controlBar: {
        fullscreenToggle: false,
        pictureInPictureToggle: false,
        remainingTimeDisplay: false,
        volumePanel: false,
        currentTimeDisplay: false,
        timeDivider: false,
        durationDisplay: false,
        liveDisplay: false,
        seekToLive: false
      }
    }

    modalPlayer = videojs(player, options);
    modalPlayer.addClass('vjs-nama');
  }

  const openModal = trigger => {
    html.style.overflow = 'hidden';
    const videoType = trigger.getAttribute('data-modal-trigger-video-type').toLowerCase();
    const videoUrl = trigger.getAttribute('data-modal-trigger-video');
    const isIframe = (videoType === 'youtube' || videoType === 'vimeo') ? true : false;

    videoContainer = modal.querySelector(isIframe ? 'iframe' : 'video');
    ogVideoWrapper = videoContainer.cloneNode(true);

    videoContainer.style.display = "block";

    if(!isIframe)
      videoContainer.querySelector('source').src = videoUrl;

    initPlyr(videoContainer, videoType, videoUrl, isIframe);

    modal.style.display = 'flex';
  }

  const closeModal = () => {
    html.style.overflow = 'auto';
    modal.style.display = 'none';
    modalPlayer.dispose();
    modalPlayer = undefined;
    modalVideoContainer.appendChild(ogVideoWrapper);
  }

  allTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => openModal(trigger))
  })

  modal.addEventListener('click', e => {
    if(e.target.classList.contains('product-page__modal'))
      closeModal()
  })
  
  closeButton.addEventListener('click', () => closeModal());

})()